import http from './http';

export async function getWeekendStatsLatest() {
  const { data } = await http.get('/admin/weekend-stats/latest');
  return data;
}

export async function purgeInvalidSnapshots() {
  const { data } = await http.delete('/admin/weekend-stats/invalid-snapshots');
  return data;
}
